import React from 'react';
import OnDemand from '@peoplenet/vi-components-ui/src/OnDemand/container/OnDemand';
import { hasOnDemandPermission } from '../security/util';

const onDemand = () => {
  const canChange = hasOnDemandPermission();
  return (
    <div className="bodycontent bodycontent__ondemand">
      <OnDemand canChangeStatus={canChange} />
    </div>
  );
};
export default onDemand;
